<template>
  <!--<div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>-->
  <section>
    <main-menu
      :active="activeMenu"
      v-on:activate="activeMenu = true"
    ></main-menu>
    <router-view/>
    <main-footer
      v-on:click="activeMenu = false"
    ></main-footer>
    <notifications
      group="system_alerts_success"
      classes="notification is-success"
      position="bottom right"
      duration="5000"
    />
    <notifications
      group="system_alerts_danger"
      classes="notification is-danger"
      position="bottom right"
      duration="5000"
    />
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import MainMenu from '@/components/MainMenu.vue';
import MainFooter from '@/components/MainFooter.vue';

export default {
  // https://github.com/kyvg/vue3-notification
  components: {
    MainMenu,
    MainFooter,
  },
  computed: {
    ...mapGetters([
      'notifications',
    ]),
  },
  watch: {
    notifications(newNotification) {
      this.$notify(newNotification);
    },
    $route() {
      this.activeMenu = false;
    },
  },
  data: () => ({
    activeMenu: false,
  }),
};
</script>

<style lang="scss">
  @import '@/assets/styles/colors.scss';
  body{
    overflow-x: hidden;
  }
  .content-view{
    padding-top: min(95px, 20vh);
    min-height: 70vh;
  }
  .section h2{
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 30px;
    color: #000;
  }
  .section p{
    margin-bottom: 20px;
    color: #000;
  }
  .primary-background{
    background-color: $primary !important;
    color: $light !important;
  }
</style>
